import { render, staticRenderFns } from "./ShowOpenOrders.vue?vue&type=template&id=410af40c"
import script from "./ShowOpenOrders.vue?vue&type=script&lang=js"
export * from "./ShowOpenOrders.vue?vue&type=script&lang=js"
import style0 from "./ShowOpenOrders.vue?vue&type=style&index=0&id=410af40c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports